/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import styles from './fileList.module.css';

const FilesListItem = ({ name, id, onClear, uploadComplete }: any) => {
  const handleClear = useCallback(() => {
    onClear(id);
  }, []);

  return (
    <li className={styles.files_list_item}>
      <span className={styles.files_list_item_name}>{name}</span>
      {!uploadComplete ? (
        <span
          className={styles.files_list_item_clear}
          role="button"
          aria-label="remove file"
          onClick={handleClear}
        >
          <CloseIcon />
        </span>
      ) : (
        <span role="img" className={styles.file_list_item_check}>
          <CheckIcon />
        </span>
      )}
    </li>
  );
};

const FilesList = ({ files, onClear, uploadComplete }: any) => (
  <ul className={styles.files_list}>
    {files.map(({ file, id }: any) => (
      <FilesListItem
        name={file.name}
        key={id}
        id={id}
        onClear={onClear}
        uploadComplete={uploadComplete}
      />
    ))}
  </ul>
);

export default FilesList;
